export function AllocationPie({ percentage }: { percentage: number }) {
  const size = 24;
  const vb = 32;
  const cx = vb / 2;
  const cy = vb / 2;
  const outlineRadius = 12;
  const sliceRadius = 10;
  const p = Math.max(0, Math.min(1, percentage / 100));

  const angle = 2 * Math.PI * p;
  const endX = cx + sliceRadius * Math.sin(angle);
  const endY = cy - sliceRadius * Math.cos(angle);
  const largeArc = p > 0.5 ? 1 : 0;

  const slicePath =
    p >= 1
      ? `M ${cx} ${cy - sliceRadius} A ${sliceRadius} ${sliceRadius} 0 1 1 ${cx - 0.001} ${cy - sliceRadius} Z`
      : `M ${cx} ${cy} L ${cx} ${cy - sliceRadius} A ${sliceRadius} ${sliceRadius} 0 ${largeArc} 1 ${endX} ${endY} Z`;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${vb} ${vb}`}
      className="shrink-0 text-slate-400"
      shapeRendering="geometricPrecision"
      aria-hidden="true"
    >
      <circle
        cx={cx}
        cy={cy}
        r={outlineRadius}
        fill="none"
        stroke="currentColor"
        strokeOpacity={0.45}
        strokeWidth={1.5}
      />
      {p > 0 && <path d={slicePath} fill="currentColor" />}
    </svg>
  );
}
